import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import History from 'static/script/utils/history';
import fullPath from 'static/script/utils/full-path';
import WithAjax from 'static/script/app/data/with-ajax';
import InitData from 'static/script/app/data/init-data';
import 'static/script/utils/console';

function NavigationData() {

    this.defaultAttrs({
        pageContainer: '#page-container',
        noShowError: true,
        enablePushState: true,
        version: null
    });

    let initialState = true;
    let initialVersion;

    this.navigate = function (evt, eventData) {
        if (this.shouldUsePushState(eventData)) {
            this.loadPage(eventData.href);
        } else {
            this.fullPageReload(eventData.href);
        }
    };

    this.shouldUsePushState = function (eventData) {
        return window.Feature.detected.history && !window.Feature.detected['ie-ieMobile'] && !eventData.withFullPageLoad && this.attr.enablePushState;
    };

    this.fullPageReload = function (href) {
        window.location.href = href;
    };

    this.loadPage = function (href) {
        this.trigger(document, 'data:navigation:before-page-load');

        let success = function (html) {
            this.dataPageReceived(html, href);
        };

        let error = function (initData, jqXHR) {
            if (/\.ngx$/.test(document.location.host)) {
                console.log('pjax navigation error!');
            }
            this.dataPageFetchError(initData, jqXHR, href);
        };

        this._get({
            url: href,
            requestId: 'pjax',
            dataType: 'html',
            headers: { 'x-push-state-request': 'true' },
            success: success.bind(this),
            error: error.bind(this)
        });
    };

    this.dataPageReceived = function (html, href) {

        let initData = InitData.setFromHtml(html);

        if (initData && initData.version !== initialVersion) {
            this.fullPageReload(href);
            return;
        }

        initData.href = href;
        initData.viewHtml = html;

        if (!this.isPopState) {
            History.pushState({ href: href }, initData.title, href);
        }

        initData.isPopState = this.isPopState;

        InitData.set(initData);

        $(document).trigger('data:navigation:after-page-load', initData);
    };

    this.dataPageFetchError = function (initData, jqHXR, href) {
        if (initData && initData.module) {
            this.dataPageReceived(initData, href);
        }
        else {
            this.fullPageReload(href);
        }
    };

    this.onPopState = function (e) {

        if (!e.originalEvent) {
            return;
        }

        if (this._navigationPaused) {
            return;
        }

        if (e.originalEvent.state) {
            let path = fullPath();

            if (this._needsFullPageLoad(path)) {
                this.fullPageReload(path);
            }
            else {
                this.isPopState = true;
                this.loadPage(path);
            }
        }
    };

    this._needsFullPageLoad = function (path) {
        let initData = InitData.current();
        return ((initData && initData.subModule ? initData.subModule : '').indexOf('/mytradera/') === -1 && path.indexOf('/my/') !== -1);
    };

    this.createInitialState = function () {
        History.replaceState({}, document.title, fullPath());
    };

    this.doTeardown = function () {
        defineComponent.component.teardownAll();
    };

    this.destroyCurrentPageState = function () {
        History.replaceState(null, document.title, fullPath());
    };

    this.pauseNavigation = function () {
        this._navigationPaused = true;
    };

    this.resumeNavigation = function () {
        this._navigationPaused = false;
    };

    this.after('initialize', function () {
        this.on(document, 'ui:navigate', this.navigate);
        this.on(document, 'ui:teardown', this.doTeardown);

        if (this.attr.enablePushState) {
            this.on(document, 'ui:pause-navigation', this.pauseNavigation);
            this.on(document, 'ui:resume-navigation', this.resumeNavigation);
            this.on(window, 'popstate', this.onPopState);
            this.on(window, 'beforeunload', this.destroyCurrentPageState);
            this.isPopState = false;

            if (initialState) {
                this.createInitialState();
                initialState = false;
                initialVersion = this.attr.version;
            }
        }
    });
}

export default defineComponent.component(NavigationData, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/navigation.js